// extracted by mini-css-extract-plugin
module.exports = {"githubBtnBox":"style_githubBtnBox__xmhta","githubBtn":"style_githubBtn__Lrfkp"};